import { instance, errorService, savePreviousData } from '@/services/api'
import { templateAPIs } from '@/services/authConstantsV1'
import _ from 'lodash'
import Vue from 'vue'
import { socketEvents } from '@/services/config'
import { showNotification } from '@/services/calculate'
import DynamicTable from '@/components/DynamicComponents/Templates/Grid'

export default {
  components: {
    DynamicTable,
  },
  props: [
    'child',
    'templateData',
    'screenIndentifier',
    'dropdownData',
    'tableId',
    'screen_Name',
    'projectModule',
    'type',
    'viewOnly',
    'columnSettings',
  ],
  data() {
    return {
      dropdownInfo: this.dropdownData,
      savePreviousData: savePreviousData,
      columnDefs: [],
      loader: false,
      openCreate: false,
      create: new Vue(),
      componentKey: 0,
      buildingData: this.templateData,
      form: {
        id: undefined,
        constructionQualityFactor: undefined,
        constructionQualityFactorValue: undefined,
        conditionFactor: undefined,
        conditionFactorValue: undefined,
        takeoff: [],
        screenName: 'Building Shell',
      },
      loading: false,
    }
  },
  beforeMount() {
    this.loadingConfig()
  },
  created() {
    this.child.$off('addNewRecord')
    this.child.$on('addNewRecord', this.addNewRecord)
  },
  mounted() {
    this.$socketHub.$on('message-received', this.recievedMessage)
    this.getBuildingShell()
  },
  beforeDestroy() {
    this.child.$off('addNewRecord')
  },
  methods: {
    loadingConfig() {
      this.columnDefs = [
        {
          rowDrag: true,
          headerName: '',
          field: 'display',
          floatingFilter: false,
          width: 3,
          suppressSizeToFit: true,
          resizable: false,
          editable: false,
          sortable: false,
          pinned: 'left',
          menuTabs: [],
        },
        {
          checkboxSelection: true,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
          resizable: false,
          editable: false,
          pinned: 'left',
          menuTabs: [],
        },
        {
          headerName: '',
          field: 'isLocked',
          headerTooltip: 'Locked',
          width: 30,
          editable: false,
          cellRenderer: 'lockRenderer',
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'int',
            viewOnly: this.viewOnly,
          },
          floatingFilter: false,
          resizable: false,
          suppressSizeToFit: true,
          hide: true,
          pinned: 'left',
          menuTabs: [],
        },
        {
          headerName: '',
          field: 'isValidTakeoff',
          width: 5,
          hide: true,
          floatingFilter: false,
          suppressSizeToFit: true,
          resizable: false,
          editable: false,
        },
        {
          headerName: 'Contract',
          field: 'contract',
          cellStyle: { textAlign: 'left' },
          width: 100,
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'int',
          },
          headerTooltip: 'Contract',
          suppressSizeToFit: true,
          resizable: true,
        },
        {
          headerName: 'Category Code',
          field: 'categoryCode',
          cellStyle: { textAlign: 'left' },
          width: 150,
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'string',
          },
          headerTooltip: 'Category Code',
          suppressSizeToFit: true,
          resizable: true,
        },
        {
          headerName: 'Additional Description',
          field: 'additionalDescription',
          headerClass: 'header-center',
          cellStyle: { textAlign: 'center' },
          cellEditor: 'textEditor',
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'string',
            placeholder: 'Additional Description',
          },
          width: 150,
          headerTooltip: 'Additional Description',
          suppressSizeToFit: true,
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Takeoff Description',
          field: 'takeoff',
          cellEditor: 'takeoffSelectEditor',
          cellStyle: { textAlign: 'left' },
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'string',
            name: 'takeoff_Name',
            screen: this.projectModule ? 'Project' : 'Template',
          },
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Takeoff',
          resizable: true,
          width: 420,
        },
        {
          headerName: 'Calculation',
          field: 'calculation',
          cellEditor: 'calculationEditor',
          cellStyle: { textAlign: 'left' },
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'string',
            name: 'calculation',
            dropdownData: this.dropdownInfo.calculation,
          },
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Calculation',
          resizable: true,
          sortable: false,
          floatingFilter: false,
          width: 100,
        },
        {
          headerName: 'Quantity',
          field: 'quantity',
          cellEditor: 'inputNumberEditor',
          cellStyle: { textAlign: 'right' },
          headerClass: 'header-right',
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'int',
            placeholder: 'Quantity',
            precision: 0,
            min: 0,
            max: 999999999,
          },
          width: 100,
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Quantity',
          resizable: true,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Unit',
          field: 'unit',
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          width: 100,
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: {
            type: 'dynamicTable',
          },
          headerTooltip: 'Unit',
          resizable: true,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Unit Cost',
          field: 'unitCost',
          cellRenderer: 'costPriceCellRenderer',
          cellStyle: { textAlign: 'right' },
          cellRendererParams: {
            type: 'dynamicTable',
          },
          width: 120,
          headerTooltip: 'Unit Cost',
          resizable: true,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Condition Factor',
          field: 'conditionFactor',
          headerClass: 'header-center',
          cellEditor: 'selectEditor',
          wrapText: false,
          filter: 'customFilter',
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'int',
            dropdownName: 'conditionFactor',
            dropdownData: this.dropdownData.condition_factor,
            name: 'conditionFactor',
            width: '350px !important',
            editable: true,
          },
          width: 150,
          headerTooltip: 'Condition Factor',
          suppressSizeToFit: true,
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Multiplier',
          field: 'multiplier',
          cellStyle: { textAlign: 'right' },
          headerClass: 'header-right',
          cellEditor: 'inputNumberEditor',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: {
            name: 'multiplier',
            type: 'dynamicTable',
            dataType: 'int',
            precision: 3,
          },
          width: 100,
          headerTooltip: 'Multiplier',
          suppressSizeToFit: true,
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          cellRenderer: 'actionCellRenderer',
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellRendererParams: {
            screenType: 'Template',
          },
          floatingFilter: false,
          width: 60,
          resizable: false,
          suppressSizeToFit: true,
          headerTooltip: 'Action',
          pinned: 'right',
          hide: this.viewOnly,
          menuTabs: [],
        },
      ]
    },

    getBuildingShell() {
      this.loader = true
      instance
        .get(
          templateAPIs.buildingShell.getBuildingShellDetails(
            this.$route.params.id,
          ),
        )
        .then(response => {
          this.form = _.get(response.data, 'result', null)
          this.getTakeoffs()
        })
        .catch(err => {
          this.loader = false
          errorService(err)
        })
    },

    getTakeoffs() {
      this.loader = true
      instance
        .get(
          templateAPIs.buildingShell.getTakeoffs(
            this.$route.params.id,
            this.form.id,
          ),
        )
        .then(response => {
          this.form.takeoff = _.get(response.data, 'result', [])
          this.form.takeoff.forEach(element => {
            if (element.categoryCode) {
              element.categoryCode = Number(element.categoryCode)
            }
          })
          const isValid = this.form.takeoff.some(i => i.isLocked)
          if (isValid) {
            const index = this.columnDefs.findIndex(
              i => i.field === 'isLocked',
            )
            this.columnDefs[index].hide = false
          }
          this.loader = false
        })
        .catch(err => {
          this.loader = false
          errorService(err)
        })
    },

    updateTakeOff(takeOff, isSocket) {
      this.form.takeoff = [...takeOff]
    },

    addNewRecord() {
      this.create.$emit('addRecord')
    },

    updateColumnSettings(request) {
      this.$emit('updateColumnSettings', request)
    },

    recievedMessage(message) {
      this.$notification.destroy()
      const data = JSON.parse(message.message)
      if (data.EventType === socketEvents.templateSideBarUpdated) {
        this.$root.$emit('templateSideBarUpdated', message)
      } else if (data.EventType === socketEvents.buildingShellUpdated) {
        this.$root.$emit('popupUpdation', false, true, null)
        showNotification(
          'error',
          'Socket',
          _.get(data, 'Result', null),
        )
      } else if (data.EventType === socketEvents.error) {
        this.$root.$emit('popupUpdation', false, true, null)
        showNotification(
          'error',
          'Socket',
          _.get(data, 'Result', null),
        )
      }
    },
  },
}
